import { useState } from 'react';

const faqList = [
  {
    q: 'Зачем компании оценивать сотрудников?',
    a: 'Оценка сотрудников нужна не ради рейтинга, а для принятия управленческих решений: понять, какие компетенции уже развиты, каких не хватает, кто готов к более сложной роли, кому требуется обучение, кого можно включить в кадровый резерв и где находятся риски для бизнеса.',
  },
  {
    q: 'Что можно оценивать у сотрудников?',
    a: 'Набор компетенций формируется под конкретную должность и задачи бизнеса. Чаще всего оценивают профессиональные компетенции, коммуникацию, ответственность, инициативность, работу в команде, управленческие компетенции, лидерство, а для отдела продаж — навыки коммуникации с клиентами, выявления потребностей, презентации ценности, работы с возражениями и переговоров.',
  },
  {
    q: 'Какие методы оценки сотрудников используются?',
    a: 'Используются структурированные интервью, ассессмент-центр, оценка 360 градусов, тестирование, практические задания, анализ рабочих результатов и комплексная оценка, комбинирующая несколько методов. Метод подбирается под задачу оценки, а не наоборот.',
  },
  {
    q: 'Что такое оценка компетенций?',
    a: 'Оценка компетенций — это определение того, какими знаниями, навыками и моделями поведения обладает сотрудник и как они соотносятся с требованиями его роли и задачами бизнеса. Она выявляет сильные стороны и зоны развития и становится основой для плана развития.',
  },
  {
    q: 'Чем оценка сотрудников отличается от оценки эффективности обучения?',
    a: 'Оценка сотрудников отвечает на вопрос, что сотрудник умеет сейчас и что ему нужно развивать. Оценка эффективности обучения отвечает на другой вопрос — изменилось ли что-то после уже проведённого обучения. Первая определяет потребность в развитии, вторая — результат обучения.',
  },
  {
    q: 'Можно ли оценивать сотрудников перед обучением?',
    a: 'Да, это один из самых полезных сценариев. Оценка перед обучением показывает текущий уровень сотрудников и дефициты, что позволяет нацелить программу на реальные потребности, а не проводить обучение для всех одинаково.',
  },
  {
    q: 'Можно ли по результатам оценки составить индивидуальный план развития?',
    a: 'Да. По результатам оценки для сотрудника формируется индивидуальный план развития, который фиксирует компетенцию, текущий и желаемый уровни, конкретные действия, сроки и критерии результата. Так оценка превращается в понятные шаги развития.',
  },
  {
    q: 'Как оценка помогает формировать кадровый резерв?',
    a: 'Оценка выявляет сотрудников с высоким потенциалом, определяет их готовность к новой роли и выявляет дефицит управленческих компетенций. На этой основе строится индивидуальный план развития: обучение, наставничество, практика и повторная оценка.',
  },
  {
    q: 'Можно ли проводить оценку руководителей?',
    a: 'Да. Для руководителей оцениваются управленческие компетенции: постановка задач, делегирование, контроль, обратная связь, развитие сотрудников и лидерство. Оценка руководителей связана с развитием управленческих компетенций и подготовкой кадрового резерва.',
  },
  {
    q: 'Можно ли адаптировать модель оценки под конкретную компанию?',
    a: 'Да. Модель компетенций и критерии оценки формируются под конкретные должности, отрасль и задачи бизнеса. Универсального списка компетенций, который подходит всем компаниям одинаково, не существует.',
  },
  {
    q: 'Сколько времени занимает оценка сотрудников?',
    a: 'Продолжительность зависит от количества сотрудников, глубины оценки и выбранных методов. Оценка одной группы может занимать от нескольких дней до нескольких недель, включая подготовку инструментов, проведение оценочных мероприятий и анализ результатов. Точные сроки определяются после постановки задачи.',
  },
  {
    q: 'Что компания получает по результатам оценки?',
    a: 'Компания получает понятную картину компетенций сотрудников, выявленные зоны развития, понимание потенциала команды, кадровый резерв, индивидуальные планы развития и связь оценки с обучением. Это позволяет направлять бюджет на обучение туда, где он действительно нужен.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="py-16 md:py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Часто задаваемые вопросы
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-14 max-w-3xl mx-auto leading-relaxed">
          Ответы на ключевые вопросы об оценке и развитии сотрудников
        </p>

        <div className="space-y-4">
          {faqList.map((item, i) => (
            <div key={i} className="bg-gray-50 rounded-xl border border-gray-200 overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-5 text-left hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <span className="font-bold text-gray-900 pr-4 text-sm md:text-base">{item.q}</span>
                <i className={`ri-arrow-down-s-line text-xl text-teal-600 flex-shrink-0 transition-transform ${openIndex === i ? 'rotate-180' : ''}`}></i>
              </button>
              <div className={`px-6 pb-5 ${openIndex === i ? '' : 'hidden'}`}>
                <p className="text-gray-600 leading-relaxed text-sm md:text-base">{item.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}